export default "__VITE_ASSET__DAFjV1Yn__"